import { Avatar, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const EditProfileMian = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  [theme.breakpoints.between("md", "lg")]: {
    width: "80%",
    margin: "0 auto",
  },
}));
const UserAvatarMian = styled("div")(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  width: "70px",
  height: "70px",
  [theme.breakpoints.down("md")]: {
    margin: "0 auto",
  },
}));
const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: "70px",
  height: "70px",
  backgroundColor: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));

const CameraButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  right: 0,
  width: "20px",
  height: "20px",

  color: "#000000",
  background: "#0B0B0B",
  border: "1.8px solid #FFFFFF",
  boxShadow: "0px 4.8px 96px rgba(167, 174, 193, 0.3)",
  borderRadius: "36px",
  "& svg": { fontSize: "10px", color: "#fff" },
  "&:hover": {
    backgroundColor: "#FFFFFF",
    "& svg": { color: "#0B0B0B", fontSize: "10px" },
  },
}));

const FormMain = styled("div")(({ theme }) => ({
  width: "70%",
  marginTop: "40px",
  marginBottom: "170px",
  "& .inputsMain": {
    marginBottom: "20px",
    position: "relative",
  },
  "& label": {
    display: "block",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: theme.palette.colors.BlackBean,
    fontFamily: theme.typography.fontFamily,
  },
  "& input": {
    width: "100%",
    height: "48px",
    background: "#F2F2F2",
    border: "1px solid #0B0B0B",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: theme.palette.colors.BlackBean,
    fontFamily: theme.typography.fontFamily,
    padding: "10px",
  },
  "& span.error": {
    fontFamily: theme.typography.fontFamily,
    color: "red",
    fontSize: "15px",
    position: "absolute",
    top: "86%",
    left: 0,
  },
  "& .PhoneInputsMain": {
    marginTop: "-10px",
  },
  "& .PhoneInputInput": {
    border: "1px solid #0B0B0B",
  },
  "& .CustomerTypeMain": {
    width: "100%",
    marginBottom: "10px",
    marginTop: "-10px",
    select: {
      width: "100%",
      height: "48px",
      background: "#F2F2F2",
      border: "1px solid #0B0B0B",
      borderRadius: "10px",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "25px",
      color: "#0B0B0B",
      padding: "10px",
      "&:disabled": {
        backgroundColor: "#f4f4f4",
        color: "#888888",
        border: "1px solid #dddddd",
      },
    },
  },
  "& .PhoneInput--disabled": {
    "& .PhoneInputCountry": {
      display: "none",
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginBottom: "100px",
    "& .havePhone": {
      flexDirection: "column",
      gap: "20px",
    },
  },
}));

export { FormMain, CameraButton, UserAvatar, UserAvatarMian, EditProfileMian };
